import { Divider, Spacer } from '@nextui-org/react';
import React from 'react';
import { Outlet } from 'react-router-dom';

const CubageLayout = (): JSX.Element => {
  return (
    <div className="flex grow flex-col">
      {/* Title */}
      <h1 className="text-4xl font-bold text-foreground-800">Cubagem</h1>

      <Divider className="my-4" />

      <Spacer y={4} />

      <Outlet />
    </div>
  );
};

export default CubageLayout;
